import { Tooltip } from '@papan/core-ui/ui'
import { ScheduleNextRuns } from './ScheduleNextRuns.js'

/**
 * The recurring consent-item label: a lowercase "when" prefix for triggers
 * (so the event reads grammatically — "when a file is created"), then the label
 * in a truncating, touch-friendly tooltip. Shared by every consent surface
 * (install gate, settings section, review wizard) so the "when" + tooltip can't
 * drift out of sync. Callers own the surrounding row (icons, buttons, styling).
 */
export function ConsentItemLabel({ itemType, label, schedule, textClassName = 'themed-text' }: {
  itemType: 'trigger' | 'grant' | 'schedule' | 'key' | 'key-pick' // schedule labels are self-contained ("Run … on cron … in <zone>")

  label: string
  /** A schedule's timing — adds its next run, in its zone AND on the approver's own clock,
   *  so what a person approves is when it actually fires for them. */
  schedule?: { cron?: string; tz?: string }
  /** Colour/decoration for the label text (e.g. muted + line-through when denied). */
  textClassName?: string
}) {
  const tooltip = <Tooltip content={label} className={`text-sm flex-1 truncate min-w-0 ${textClassName}`}>{label}</Tooltip>
  return (
    <>
      {itemType === 'trigger' && <span className="text-[11px] themed-text-muted lowercase shrink-0">when</span>}
      {itemType === 'schedule' && schedule?.cron
        ? <div className="flex-1 min-w-0 flex flex-col">{tooltip}<ScheduleNextRuns cron={schedule.cron} tz={schedule.tz} className="truncate" /></div>
        : tooltip}
    </>
  )
}
